// Central configuration for the real user-auth API (the /v3/... endpoints from
// dashboard.tangoeye.ai). This is SEPARATE from the store-analytics backend in
// src/api.js (which uses /api + VITE_API_TOKEN); the two coexist.
//
// In dev we go through the Vite proxy (see vite.config.js) so the browser talks
// to "/v3/..." on the dev server and Vite forwards it to the real host — this
// sidesteps CORS. In production set VITE_API_BASE to the real API origin.
// Trailing slash is stripped so paths like "/v3/..." never produce a "//".
export const API_BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/$/, "");

// The CryptoJS AES passphrase the live dashboard.tangoeye.ai frontend uses to
// encrypt the password before POST /v3/user/login. Overridable via env for
// safety/rotation.
export const AES_SECRET = import.meta.env.VITE_AES_SECRET ?? "t@ng0-ret@il-@pi-v3";

// The refresh-token endpoint:
//   GET /v3/user/refresh-token?userId={profile._id}&refreshToken={refreshToken}
// Success response mirrors login: { code:200, data:{ result:{ authenticationToken, refreshToken } } }
export const REFRESH = {
  path: "/v3/user/refresh-token",
  method: "GET",
  read: (json) => ({
    ok: json?.code === 200 && !!json?.data?.result,
    authenticationToken: json?.data?.result?.authenticationToken,
    refreshToken: json?.data?.result?.refreshToken,
  }),
};

// Default client id. A real client login's profile.clientId always wins; this
// is only the fallback for tango/internal logins that carry no clientId.
export const DEFAULT_CLIENT_ID = import.meta.env.VITE_CLIENT_ID ?? "524";

// Storage keys for the persisted session.
export const STORAGE = {
  token: "te-token",
  refresh: "te-refresh",
  profile: "te-profile",
  clientDetails: "te-client-details",
  clientId: "te-client-id",
};
